var exports = {
  "k": "x93eb46d8--fcc71d--container",
  "x": "x93eb46d8--fcc71d--button",
};

module.exports = exports;
